<template>
  <AppFormGroup v-if="applicantType === 'primary'">
    <SubHeading keypath="headings.purchase" />
    <AppField path="purchaseAmountCents" :label="purchaseAmountLabel" />
  </AppFormGroup>
  <PurchaseAmountNagModal />
</template>

<script setup lang="ts">
  import {
    useProviderConfig,
    useProviderI18n,
  } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"
  import { computed } from "vue"
  import PurchaseAmountNagModal from "@/components/modal/PurchaseAmountNagModal.vue"

  const props = defineProps<FormSectionProps>()

  const { t } = useProviderI18n(() => props.providerKey)

  const providerConfig = useProviderConfig(() => props.providerKey)
  const isMpq = computed(
    () => providerConfig.value?.providerProduct === "synchrony-multi-product"
  )

  const purchaseAmountLabel = computed(() =>
    isMpq.value
      ? t("appFields.mpqPurchaseAmountCents.label")
      : t("appFields.purchaseAmountCents.label")
  )
</script>

<i18n lang="yaml" locale="en">
appFields:
  mpqPurchaseAmountCents:
    label: Requested Credit Limit
headings:
  purchase: Purchase Information
</i18n>
